import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { ConfigurationServices } from '../../configuration/services';
import { TakeawayServices } from '../services';
/**
 * Generated class for the TpvTicketSelectedPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-discount-restaurantticket',
  templateUrl: 'takeaway-order-discount-restaurantticket.html',
})
export class TakeawayOrderDiscountRestaurantticketPage {
  type: any;
  percentage: any = 0;
  total: any = 0;
  valor: any = 0;
  discounted: any = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {
    this.type = this.navParams.get('type');
    //getIndexByTableuid
    this.takeawayServices.getIndexByTableuid();
    //totalTicketSelected
    this.total = takeawayServices.totalTicketSelected(takeawayServices.selected_table_tpv_index);

  }

  back() {
    this.navCtrl.pop();
  }

  applyDiscount(number) {
    this.percentage = number;
    //calculate
    this.calculate();
  }

  onchangeDiscount() {
    this.calculate();
  }

  async calculate() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //totalTicketSelected
    this.total = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index);
    this.discounted = (this.total * this.percentage) / 100;
    this.total = this.total - this.discounted;
  }

  async restart() {
    this.percentage = 0;
    this.valor = 0;
    this.discounted = 0;
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //totalTicketSelected
    this.total = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index);
  }

  async onChange() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //totalTicketSelected
    this.total = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index);
    this.total = this.total - this.valor;
  }

  async saveDiscounts() {
    var name = '';
    if (this.type == 'discount') {
      name = 'Descuento ' + this.percentage + '%';
      this.takeawayServices.insertTableDiscount(name, -Math.abs(this.discounted), false, true, 'discount', '', 'discount', this.discounted, this.globals.RESTAURANT_TAX);
      this.takeawayServices.deleteKeyboard();
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();
      //listSelectedTicket
      this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list));
      this.navCtrl.pop();
      this.navCtrl.pop();

    } else {
      name = 'Ticket restaurante ' + this.valor + '' + this.globals.currency_symbol;
      this.takeawayServices.insertTableDiscount(name, -Math.abs(this.valor), false, true, 'restaurant_ticket', '', 'restaurant_ticket', this.valor, this.globals.RESTAURANT_TAX);
      this.takeawayServices.deleteKeyboard();
      //getIndexByTableuid
      await this.takeawayServices.getIndexByTableuid();
      //listSelectedTicket
      this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list));
      this.navCtrl.pop();
      this.navCtrl.pop();
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-discount-restaurantticket/takeaway-order-discount-restaurantticket.ts